import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { MatBottomSheet } from '@angular/material';
import { EnquiryComponent } from '../enquiry/enquiry.component';
import { EnquiryStateService } from '../services/enquiry-state.service';
import { LocationMappingService } from '../services/location-mapping.service';
import { checkCookieForUsername, getCookie, slugify } from '../Utils/utils';
import { Title, Meta } from '@angular/platform-browser';
import { SeminarService } from '../services/seminar.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChildren('scrollContainer') scrollContainers: QueryList<ElementRef>;
  private enquiryTimerId: any = null;

  ngAfterViewInit() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.2
  });

  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
}


  scrollLeft(index: number) {
    if (this.scrollContainers && this.scrollContainers.toArray()[index]) {
      const scrollContainer = this.scrollContainers.toArray()[index].nativeElement;
      if (scrollContainer) {
        scrollContainer.scrollLeft -= 1040;
      }
    }
  }

  scrollRight(index: number) {
    // console.log(index)
    // console.log(this.scrollContainers)
    if (this.scrollContainers && this.scrollContainers.toArray()[index]) {
      const scrollContainer = this.scrollContainers.toArray()[index].nativeElement;
      if (scrollContainer) {
        scrollContainer.scrollLeft += 1040; // Adjust scroll step as necessary
      }
    }
  }
  public allData=[];
  public exp=0;
  public stud=0;
  public proj=0;
  public centers=0;
  public slideIndex = 0;
  public spotlight=[ 
    {
      "date": "24/11/2020",
      "time": "4:30pm",
      "event": "Digital Marketing seminar"

    },
    {
      "date": "11/11/2020",
      "time": "2:30pm",
      "event": "Full Stack seminar"

    },
    {
      "date": "24/09/2020",
      "time": "9:30am",
      "event": "Android Workshop"

    }
  ];
  public features=[
    {
      "Banner":"../../assets/gifs/stopwatch.gif",
      "Feature":"Time Flexibilities",
      "Description":"As per the College Time Table / College Schedule"
    },
    {
      "Banner":"../../assets/gifs/calendar.gif",
      "Feature":"Batch Flexibilities",
      "Description":"Batches as per college availability- Regular, Weekend, Sunday, Workshops"
    },
    {
      "Banner":"../../assets/gifs/doubt.gif",
      "Feature":"Doubt Clearing Session",
      "Description":"2 hours doubt session after completion of training at no charges"
    },
    {
      "Banner":"../../assets/gifs/cost.png",
      "Feature":"Low Fee Structure",
      "Description":"Our Center Prices are Susidised. Affordable Cost"
    },
    {
      "Banner":"../../assets/gifs/t2p.gif",
      "Feature":"Theory To Practical",
      "Description":"Digital Course materials will be provided free to every student"
    },
    {
      "Banner":"../../assets/gifs/job.gif",
      "Feature":"Job Assistance",
      "Description":"Job assistance and Visual & Video Resume Building Process"
    },
    {
      "Banner":"../../assets/gifs/certificate.gif",
      "Feature":"Verifiable Certifications",
      "Description":"NICT Verifiable certificate"
    },
    {
      "Banner":"../../assets/gifs/course.gif",
      "Feature":"Course Materials",
      "Description":"Digital Course materials will be provided free to every student"
    }
  ];
  seminars : any[] = [];
  seminar = {
  fullName: '',
  email: '',
  phone: '',
  sessionId: ''
};
showForm: boolean = false;

  // General FAQs for home page
  public generalFAQs = [
    {
      question: "What makes NICT different from other computer training institutes?",
      answer: "NICT has been providing quality computer education since 1997 with flexible batch timings, affordable fees, hands-on practical training, verifiable certificates, and job assistance. We have multiple branches across Bangalore for your convenience."
    },
    {
      question: "Do you offer both online and offline classes?",
      answer: "Yes, we offer both online and offline training options. You can choose the mode that suits your preference and schedule."
    },
    {
      question: "Can I switch between branches?",
      answer: "Yes, our courses are designed to allow flexibility. You can attend classes at any of our branches based on your convenience, subject to batch availability."
    },
    {
      question: "What types of courses do you offer?",
      answer: "We offer a wide range of courses including Programming, Web Development, Digital Marketing, Data Science, SAP, Accounting (Tally), Graphic Design, and many more professional computer courses."
    },
    {
      question: "How do I enroll in a course?",
      answer: "You can enroll by visiting any of our branches, calling us at +91-8618958330, or filling out the enquiry form on our website. We'll guide you through the admission process."
    },
    {
      question: "Is EMI payment option available?",
      answer: "Yes, we offer flexible payment options including EMI for select courses. Please contact our admissions team for more details."
    }
  ];



  constructor(
    private snackbars: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private bottomSheet: MatBottomSheet,
    private enquiryStateService: EnquiryStateService,
    private locationMappingService: LocationMappingService,
    private titleService: Title,
    private metaService: Meta,
    private seminarService: SeminarService
  ) { }

  ngOnInit() {

    this.titleService.setTitle('Best Computer Courses in Bangalore | NICT Computer Education');
    this.metaService.updateTag({
      name: 'description',
      content: 'NICT offers the best computer training programs in Bangalore with flexible timing, affordable fees, expert faculty, and industry-recognized certifications.'
    });

    // Optional: Open Graph Tags (for Facebook, LinkedIn, WhatsApp sharing)
    this.metaService.updateTag({ property: 'og:title', content: 'Best Computer Courses in Bangalore | NICT' });
    this.metaService.updateTag({ property: 'og:description', content: 'Join NICT for hands-on IT training, certifications, and job assistance. Flexible batches and modern labs.' });
    this.metaService.updateTag({ property: 'og:image', content: 'https://www.nictcomputereducation.com/assets/logo.ico' }); // Adjust with actual logo/image
    this.metaService.updateTag({ property: 'og:url', content: 'https://www.nictcomputereducation.com' });
    this.dataService.getCachedCourses().subscribe(res =>{
      this.allData=res;
    })

    this.loadSeminars();

    // Store the timer id so it can be cancelled in ngOnDestroy - otherwise it keeps
    // running after the user navigates away and pops the bottom sheet open on whatever
    // page they land on next (duplicate/leftover enquiry popups).
    this.enquiryTimerId = setTimeout(() => {
      // Only show enquiry if:
      // 1. User hasn't submitted enquiry (no cookie)
      // 2. Enquiry hasn't been shown yet in this session
      if (!this.enquiryStateService.hasEnquiryBeenSubmitted() && 
          !this.enquiryStateService.hasEnquiryBeenShown()) {
        
        // Mark as shown to prevent duplicate popups
        this.enquiryStateService.markEnquiryAsShown();
        
        // Get location from URL if available
        const locationFromUrl = this.getLocationFromUrl();
        
        this.bottomSheet.open(EnquiryComponent,{
          data: {
            source: "Home Page",
            location: locationFromUrl
          },
          disableClose: false
        });
      }
    }, 15000);
      
  }

  ngOnDestroy(): void {
    if (this.enquiryTimerId) {
      clearTimeout(this.enquiryTimerId);
      this.enquiryTimerId = null;
    }
  }

  getLocationFromUrl(): string | null {
    const locationParam = this.route.snapshot.paramMap.get('location');
    if (locationParam) {
      // Store the slug and get location
      return this.locationMappingService.getLocationAndStore(locationParam);
    }
    // If no location in URL, check localStorage
    return this.locationMappingService.getStoredLocation();
  }

  loadSeminars(): void {
    this.seminarService.getSeminarSessions().subscribe({
      next: (response) => this.seminars = (response.body as any[]) || [],
      error: (err) => {
        console.error('Failed to fetch seminars:', err);
        this.seminars = [];
      }
    });
  }

  getSeatFillingLevel(session: any): 'fast' | 'last-few' | 'full' | null {
    const filled = session.totalSeats - session.availableSeats;
    const filledPercentage = (filled / session.totalSeats) * 100;
    if (session.availableSeats === 0) return 'full';
    if (filledPercentage >= 70) return 'last-few';
    if (filledPercentage >= 50) return 'fast';

    return null;
  }



  enrollNow(courseName: String): void {
      // Get location from URL if available
      const locationFromUrl = this.getLocationFromUrl();
      
      this.bottomSheet.open(EnquiryComponent,{
        data: {
          courseName: courseName,
          source: "course syllabus",
          location: locationFromUrl
        }

  
      });
  }

  openEnquiryForm(): void {
    // Get location from URL if available
    const locationFromUrl = this.getLocationFromUrl();
    
    this.bottomSheet.open(EnquiryComponent, {
      data: {
        courseName: '',
        source: "home page CTA",
        location: locationFromUrl
      }
    });
  }

  formatToAmPm(timeString: string): string {
    if (!timeString) return '';

    const [hourStr, minuteStr] = timeString.split(':');
    let hour = parseInt(hourStr, 10);
    const minute = minuteStr.padStart(2, '0');
    const ampm = hour >= 12 ? 'PM' : 'AM';

    hour = hour % 12;
    if (hour === 0) hour = 12;

    return `${hour}:${minute} ${ampm}`;
  }

  registerForSeminar() {
  // console.log('Form Submitted:', this.seminar);
    if (this.seminar.fullName && this.seminar.email && this.seminar.phone && this.seminar.sessionId) {
      this.seminarService.registerForSeminar(this.seminar).subscribe({
        next: (response) => {
          this.snackbars.open("Registration successful!", '', {
            duration: 3 * 1000,
            panelClass: ['green-snackbar'],
            horizontalPosition: "right",
            verticalPosition: "bottom"
          });
          this.seminar = { fullName: '', email: '', phone: '', sessionId: '' };
          console.log('Registration successful:', response);
        },
        error: (error) => {
          console.error('Registration failed:', error);
        }
      });
    }
  }


  selectSeminar(session: any): void {
    this.seminar.sessionId = session.id;
    this.showForm = true;
  }



  filterCourses(category: string): any[] {
    return this.allData.filter(course => course.category === category && 
      course.status == true && 
      course.price > 25000 && 
      !course.courseName.toLowerCase().includes('data science') &&
      !course.courseName.toLowerCase().includes('full stack development'));
  }

  startodo()
  {
    // console.log("in scroll")
    this.exp=25;
    this.stud=400000;
    this.proj=1000;
    this.centers=40;
  }


  viewCourseDetails(courseName: string) {
  const courseSlug = slugify(courseName);
  this.router.navigate([`/courses/${courseSlug}`]);
}


  public message(){
    this.snackbars.open("Thank You for Enrolling! See you soon :)",'',{
      duration: 3 * 1000,
      panelClass: ['green-snackbar'],
      horizontalPosition: "right",
      verticalPosition: "bottom"
    });
  }
  
  public plusSlides(n) {
    // this.showSlides(this.slideIndex += n);
  }
  
  public currentSlide(n) {
    // this.showSlides(this.slideIndex = n);
  }
  
  public showSlides() {
    
      var i;
      var slides = document.getElementsByClassName("mySlides");
      if (this.slideIndex >= slides.length) {this.slideIndex = 0}   
      // console.log(this.slideIndex)
      var dots = document.getElementsByClassName("dot");
      for (i = 0; i < slides.length; i++) {
        slides[i].setAttribute("style","display: none;");    
      }
      
       
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      this.slideIndex++; 
      slides[this.slideIndex-1].setAttribute("style","display: block;")
      dots[this.slideIndex-1].className += " active";
      setTimeout(() => {
        this.showSlides();
      }, 2500);
      // setTimeout(this.showSlides, 2000); // Change image every 2 seconds


  

  }

}

